import { useRef, useState } from 'react';

import { CorePassFinalApproval } from './index';

export const useCorePassFinalApproval = () => {
  const [isOpen, setIsOpen] = useState(false);
  const pendingAction = useRef<(() => void) | null>(null);

  const requestApproval = (action: () => void) => {
    pendingAction.current = action;
    setIsOpen(true);
  };

  const close = () => {
    pendingAction.current = null;
    setIsOpen(false);
  };

  const accept = () => {
    const action = pendingAction.current;
    pendingAction.current = null;
    setIsOpen(false);
    action?.();
  };

  const approval = <CorePassFinalApproval isOpen={isOpen} onClose={close} onAccept={accept} />;

  return { requestApproval, approval };
};
